<mat-form-field (click)="picker.open()">
	@if (label || required) {
		<mat-label>{{ label }}</mat-label>
	}
	<input readonly matInput autocompleteOff
		[placeholder]="placeholder"
		[matDatepicker]="picker"
		[(ngModel)]="value"
		[min]="minDate"
		[max]="maxDate"
		[disabled]="disabled"
		[required]="required"
		[tabIndex]="-1"
		[matDatepickerFilter]="filteredDates"
		(dateChange)="valueChanged()" />
	@if (!required && value && !disabled) {
		<button matSuffix mat-icon-button (click)="$event.stopPropagation(); resetInput()" class="mat-fa-icon mat-hover-button">
			<mat-icon fontSet="fal" fontIcon="fa-times" />
		</button>
	}
	<mat-datepicker-toggle matSuffix [for]="picker" />
	<mat-datepicker #picker [dateClass]="dateClass" />
</mat-form-field>
